<template>
  <div>
    <div>
      <div v-show="errorText !== ''" v-html="errorText" class="alert alert-danger" role="alert">
        {{errorText}}
      </div>
      <div v-show="successText !== ''" class="alert alert-success" role="alert">
        {{successText}}
      </div>
    </div>
    <b-row>
      <b-col class="mt-0">
        <p>{{$t('Actualizar catalogación')}}</p>
        <b-button :disabled="inProgress || disabledCataloging" class="float-left ml-5 pr-5 pl-5"  variant="primary" @click="openModal">{{$t('Actualizar')}}</b-button>
      </b-col>
    </b-row>

    <moon-loader :loading="inProgress" color="#666" size="30px"></moon-loader>

    <b-modal ref="catalogingModal" centered :title="$t('Actualizar catalogación')" hide-footer size="lg">
      <b-form-group
        :label="$t('Ingresar correo eléctronico')"
        label-for="emailInput"
        label-align="left"
        :state="state.emailForm"
        :invalid-feedback="$t('Ingresa un correo electrónico válido')"
        >
        <b-form-input id="emailInput" v-model="email" type="email" :placeholder="$t('Correo electrónico')" required></b-form-input>
        <p class="text-muted my-2">{{ $t('Puedes colocar un mail distinto, por defecto, se asigna el correo administrativo de la sesión actual.') }}</p>
      </b-form-group>
      <b-button variant="primary" :disabled="!state.emailForm || !this.isAdmin" class="mx-2 float-right" @click="handleSubmitUpdate">{{ $t('Actualizar') }}</b-button>
      <b-button @click="closeModal" class="mx-2 float-right">{{ $t('Cancelar') }}</b-button>
    </b-modal>
  </div>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { ProductServiceMixim } from '@/mixims/ProductServiceMixim.js'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
export default {
  name: 'category-updater',
  components: {
    MoonLoader
  },
  mixins: [ProductServiceMixim, ValidationsMixim],
  data () {
    return {
      showModal: false,
      email: this.$store.getters.userData.email,
      inProgress: false,
      isAdmin: this.$store.getters.isAdmin,
      errorText: '',
      successText: '',
      disabledCataloging: false
    }
  },
  methods: {
    openModal() {
      this.$refs.catalogingModal.show()
    },
    closeModal() {
      this.$refs.catalogingModal.hide()
    },
    handleSubmitUpdate() {
      this.email.trim()
      if (this.email !== '' && this.isAdmin && this.state.emailForm) {
        this.inProgress = true
        this.updateCataloging(this.email).then((res) => {
          this.$refs.catalogingModal.hide()
          this.successText = this.$t('Catálogo Siman enviado con éxito, el procesamiento puede demorar unas horas.')
          this.inProgress = false
          this.disabledCataloging = true
        },
        (error) => {
          this.$refs.catalogingModal.hide()
          this.inProgress = false
          this.disabledCataloging = false
          this.errorText = error.body.message || this.$t('Error al actualizar el Catálogo Siman.')
        }
        )
      } else if (!this.isAdmin) {
        this.$router.push({ name: 'dashboard' })
      }
    }
  },
  computed: {
    state () {
      return {
        emailForm: Boolean(this.email) && this.validateEmail(this.email, true)
      }
    },
  }
}
</script>

<style>

</style>
